import clsx from 'clsx';
import { FieldWrapper } from './FieldWrapper';
import { ChevronDown } from 'react-feather';

export const SelectField = ({
  label,
  options,
  error,
  className,
  onSelect,
  onChange,
  caption,
  defaultValue,
  registration,
  placeholder,
  required,
}) => {
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    if (onSelect) onSelect(selectedValue);
    if (onChange) onChange(event);
  };

  return (
    <FieldWrapper label={label} error={error}>
      <div className="relative mt-2">
        <select
          onChange={handleSelectChange}
          required={required}
          defaultValue={defaultValue}
          placeholder={placeholder}
          {...registration}
          className={clsx(
            'appearance-none block w-full px-4 py-3 bg-white/5 dark:bg-white/10 text-white/90 border border-white/10 rounded-2xl shadow-inner backdrop-blur-md',
            'placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400',
            'transition duration-200 pr-10 text-sm',
            className
          )}
        >
          {options.map(({ label, value }) => (
            <option key={value} value={value} className="text-black text-sm dark:text-white bg-gray-800">
              {label}
            </option>
          ))}
        </select>
        <ChevronDown
          size={14}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-white/40 pointer-events-none"
        />
      </div>
      {caption && <span className="text-xs text-white/50">{caption}</span>}
    </FieldWrapper>
  );
};
